<div class="ipm-survey-draggable">
  <div class="ipm-visual-event-modal">
    <mat-dialog-content class="mat-typography osc-ref-dialog__content">
      <div class="ipm-visual-event-modal__content-header">
        @if (
          selectedVisualEvent.isPhotoOnlyEvent && inspectionType !== InspectionTypes.UT && inspectionType !== InspectionTypes.UT_Baseline
        ) {
          <mat-form-field>
            <mat-select
              [(value)]="selectedVisualEvent.visualEventType"
              disabled
              [placeholder]="'visualEventModal.visualEventTypePlaceholder' | translate"
            >
              <mat-option value="Nameplate">{{ 'visualEventModal.nameplate' | translate }}</mat-option>
              <mat-option value="Overview">{{ 'visualEventModal.overview' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        }
        @if (
          !selectedVisualEvent.isPhotoOnlyEvent && inspectionType !== InspectionTypes.UT && inspectionType !== InspectionTypes.UT_Baseline
        ) {
          <mat-form-field>
            <mat-select
              [(value)]="selectedVisualEvent.visualEventType"
              disabled
              [placeholder]="'visualEventModal.visualEventTypePlaceholder' | translate"
            >
              @for (eventType of visualEventTypes; track eventType) {
                <mat-option [value]="eventType">{{ eventType }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (
          !selectedVisualEvent.isPhotoOnlyEvent && inspectionType !== InspectionTypes.UT && inspectionType !== InspectionTypes.UT_Baseline
        ) {
          <mat-form-field>
            <mat-select
              [(value)]="selectedVisualEvent.visualEventStatus"
              disabled
              [placeholder]="'visualEventModal.visualEventStatusPlaceholder' | translate"
            >
              @for (status of visualEventStatus; track status) {
                <mat-option [value]="status.label">{{ status.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (isPriorityCodeRequired()) {
          <mat-form-field>
            <mat-select
              [(value)]="selectedVisualEvent.visualEventPriority"
              disabled
              [placeholder]="'visualEventModal.priorityCodePlaceholder' | translate"
            >
              @for (priorityCode of priorityCodes; track priorityCode) {
                <mat-option [value]="priorityCode.code">{{ priorityCode.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
      @if (
        !selectedVisualEvent.isPhotoOnlyEvent ||
        (selectedVisualEvent.isPhotoOnlyEvent &&
          (inspectionType === InspectionTypes.UT ||
            inspectionType === InspectionTypes.Visual ||
            inspectionType === InspectionTypes.UT_Baseline ||
            inspectionType === InspectionTypes.Visual_Baseline))
      ) {
        <div class="ipm-visual-event-modal__content-notes">
          <mat-form-field class="ipm-visual-event-modal__content-notes-area">
            <textarea
              matInput
              [placeholder]="'visualEventModal.notesPlaceholder' | translate"
              [(ngModel)]="selectedVisualEvent.description"
              disabled
            ></textarea>
          </mat-form-field>
        </div>
      }
      <div class="ipm-visual-event-modal__content-manage">
        <div class="ipm-visual-event-modal__content-image-container">
          @for (image of selectedVisualEvent.images; track image) {
            <div class="ipm-visual-event-modal__content-image-wrapper">
              <div class="ipm-visual-event-modal__content-manage-image">
                <img [ngSrc]="image.imageUrl" fill priority (click)="openImage(image.imageUrl)" />
              </div>
              @if (selectedVisualEvent.isPhotoOnlyEvent) {
                <mat-icon
                  svgIcon="icon-expand-arrows"
                  class="ipm-visual-event-modal__content-image-expand"
                  (click)="openImage(image.imageUrl)"
                ></mat-icon>
              }
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>
  </div>
</div>
